import api from "./api";

/* =========================
   GET BILLING RATES
========================= */

export const getBillingRates = () => {
  return api.get("/billing/rates");
};


/* =========================
   CREATE BILLING RATE
========================= */

export const createBillingRate = (data) => {
  return api.post("/billing/rates", data);
};


/* =========================
   DELETE BILLING RATE
========================= */

export const deleteBillingRate = (id) => {
  return api.delete(`/billing/rates/${id}`);
};


/* =========================
   CANCEL INVOICE
========================= */

export const cancelInvoice = (id) => {
  return api.post(`/billing/invoices/${id}/cancel`);
};


/* =========================
   PROJECT BILLING CALCULATION
========================= */

export const getProjectBilling = (projectId) => {
  return api.get(`/billing/project-billing/${projectId}`);
};